import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import {getValueWithoutVat} from '../helpers';
import {validateForm} from '../formValidator';

import { API, FAST_ANIMATION } from '../../../ws/constants';

class ServiceModalBox extends Component {
    /* START Constructor */

    constructor(props) {
        super(props);

        this.state = {
            clientServiceId: this.props.clientServiceId
            , clientId:this.props.clientId
            , isActive:"1"
            , isVisible:false
            , loading:false
            , services:this.props.serviceData
            , editable: this.props.editable || this.props.clientServiceId === "New"
            , modalTitle:this.props.modalTitle
            , serviceId:"0"
            , isPack:"1"
            , packNumber: 1
            , priceWithVat:""
            , priceWithoutVat:""
            , valuePaid:""
            , notes:""
        };
    }

    /* END Constructor */

    /* START React own Functions */

    componentDidMount(){
        const isNewClient = this.props.clientServiceId === "New";
        if(!isNewClient){
            this.setState({loading:true});
        }
        setTimeout(() => {
            this.setState({isVisible:true});
        }, FAST_ANIMATION);

        if(!isNewClient){
            fetch(API + "getclientservices&getbyid="+this.props.clientServiceId)
            .then(response => response.json())
            .then(result => {
                const data = result.data;

                this.setState({
                    serviceId:data.ServiceId
                    , priceWithVat:data.PriceWithVat
                    , priceWithoutVat:data.PriceWithoutVat
                    , valuePaid:data.ValuePaid
                    , missingValue:data.ValueMissing
                    , packNumber:data.Children !== null && data.Children > 1 ? data.Children : "1"
                    , isPack:data.Children !== null && data.Children > 1 ? "1": "0"
                    , notes:data.Notes
                    , isActive:data.IsActive
                    , loading:false
                });
            });
        }
    }

    /* END React own Functions */

    /* START Handles */

    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0", somethingWasEdited:true });
    handlePackToggle = (e, value) => this.setState({ isPack: value ? "1" : "0", somethingWasEdited:true, ...this.calculatePrices({ isPack: value }) });
    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });
    handleNumberFieldChange = (e) => {
        const packNumber = e.target.value > 0 ? parseInt(e.target.value) : 1;
        this.setState({ 
            packNumber
            , somethingWasEdited:true
            , ...this.calculatePrices({ packNumber })
        });
    };
    handlePriceWithVAT = (e) => {this.setState({ priceWithoutVat: getValueWithoutVat(this.state.priceWithVat, this.props.websiteSettings.VatValue), somethingWasEdited:true });};
    handlePaidValue = (e) => {
        const value = parseInt(e.target.value, 10) < parseInt(this.state.priceWithVat, 10) ? parseInt(e.target.value, 10) >= 0 ? e.target.value : 0 : this.state.priceWithVat;
        this.setState({ [e.target.id]: value, somethingWasEdited:true });};
    handleServiceChange = (e, el) => {
        let prices = this.getPriceForService(e.target.value);
        this.setState({
            serviceId: e.target.value
            , somethingWasEdited:true
            , ...this.calculatePrices({ prices })
        });
    }

    handleOk = (e) => {
        if(validateForm($(findDOMNode(this.refs.serviceModalForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false })){
            let DEFAULT_QUERY = "saveclientservice&clientserviceid=" + this.state.clientServiceId + "&clientid=" + this.state.clientId + "&serviceid=" + this.state.serviceId
                                + "&packnumber=" + this.state.packNumber + "&pricewithvat=" + this.state.priceWithVat + "&pricewithoutvat=" + this.state.priceWithoutVat
                                + "&valuepaid=" + this.state.valuePaid + "&notes=" + this.state.notes.trim() + "&isactive=" + this.state.isActive
                                + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;


            this.setState({loading:true});
            fetch(API + DEFAULT_QUERY)
            .then(response => response.json())
            .then(result => {
                this.setState({loading:false, isVisible:false});
                setTimeout(() => {
                    this.props.modalCallBack(result, false);
                }, FAST_ANIMATION);
            });
    }
    }

    handleCancel = (e) => {
        this.setState({isVisible:false});
        setTimeout(() => {
            this.props.modalCallBack(false, false); // 1st param should be the result whilst the second should be (keepModalOpen)
        }, FAST_ANIMATION);
    }

    handleDelete = () => {
        let clientServiceId = this.state.clientServiceId;
        if(window.confirm("Tem a certeza que quer apagar este serviço?")){
            this.setState({loading:true});
            fetch(API + 'deleteclientservice&clientserviceid=' + clientServiceId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false });
                this.props.modalCallBack(true, false);
            });
        }
    }

    /* END Handles */

    /* START Component Functions */

    getPriceForService = (serviceId = this.state.serviceId) => {
        let services = this.state.services;
        for(let i=0,n=services.length;i<n;i++){
            const service = services[i];
            if(service.Id === serviceId){
                return { priceWithVat: service.PriceWithVat, priceWithoutVat: service.PriceWithoutVat };
            }
        }
    }

    calculatePrices = ({ prices = this.getPriceForService(), packNumber = this.state.packNumber, isPack = this.state.isPack }) => {
        if(!prices){
            return { priceWithVat: 0, priceWithoutVat: 0 };
        }

        const priceWithVat = (isPack ? prices.priceWithVat * packNumber : prices.priceWithVat).toFixed(2);
        const priceWithoutVat = getValueWithoutVat(priceWithVat, this.props.websiteSettings.VatValue);

        return { priceWithVat, priceWithoutVat };
    }

    /* END Component Functions */

    /* START Renders */

    renderServicesOptions = (e) => {
        const services = this.state.services;
        if(services===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=services.length;i<n;i++) {
            items.push(<MenuItem value={services[i].Id}
                                 key={services[i].Id}>
                                 {services[i].Shortname + " - " + services[i].Name}</MenuItem>);
        }
        return items;
    }

    render() {
        const { canDelete } = this.props;
        const { editable } = this.state;
        const optsServices = this.renderServicesOptions();
        const isNewClient = this.props.clientServiceId === "New";
        let activeClass = this.state.isVisible ? " active" : ""
            , loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <div className="form" ref="serviceModalForm">
                <div className={"modalBox addEditPage" + activeClass + loadingClass}>
                    <button type="button" className="simpleBtn closeModal" onClick={this.handleCancel}><i className="fa fa-times"></i></button>
                    <div className="row">
                        <div className="col-12">
                            <h2>{this.props.modalTitle}
                                <span className="float-right">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                id="isActive"
                                                checked={!!+this.state.isActive}
                                                disabled={!editable}
                                                onChange={this.handleToggle}
                                                color="primary"/>
                                        }
                                        label="Ativo"/>
                                </span>
                            </h2>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="fieldHolder required selectField">
                                <InputLabel shrink={true}>Escolha o Serviço/Tratamento</InputLabel>
                                <Select fullWidth={true}
                                             id="serviceId"
                                             value={this.state.serviceId}
                                             onChange={this.handleServiceChange}
                                             disabled={!editable || !isNewClient}
                                             label="Serviço/Tratamento"
                                             placeholder="Escolha o Serviço/Tratamento"
                                             data-empty-error-message="Este campo não pode estar vazio">
                                  {optsServices}
                                </Select>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="row">
                                <div className="col-8">
                                    <div className="fieldHolder">
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    id="isPack"
                                                    checked={!!+this.state.isPack}
                                                    disabled={!editable || !isNewClient}
                                                    onChange={this.handlePackToggle}
                                                    color="primary"/>
                                            }
                                            label="Pacote"/>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="fieldHolder">
                                        <TextField fullWidth={true}
                                                   type="number"
                                                   id="packNumber"
                                                   value={this.state.packNumber}
                                                   onChange={this.handleNumberFieldChange}
                                                   label="Qtd."
                                                   disabled={!(editable && !!+this.state.isPack) || !isNewClient}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="fieldHolder moneyHolder required">
                                <TextField fullWidth={true}
                                           id="priceWithVat"
                                           value={this.state.priceWithVat}
                                           onChange={this.handleFieldChange}
                                           onBlur={this.handlePriceWithVAT}
                                           ref="priceWithVat"
                                           label="Preço com IVA"
                                           placeholder="Preço com IVA"
                                           disabled={!editable || !isNewClient}
                                           data-empty-error-message="Não pode estar vazio" />
                            </div>
                        </div>
                        <div className="col-md-4">
                                <div className="fieldHolder moneyHolder required">
                                    <TextField fullWidth={true}
                                               id="priceWithoutVat"
                                               value={this.state.priceWithoutVat}
                                               onChange={this.handleFieldChange}
                                               label="Preço sem IVA"
                                               placeholder="Preço sem IVA"
                                               disabled={true}
                                               data-empty-error-message="Não pode estar vazio" />
                               </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fieldHolder moneyHolder required">
                                <TextField fullWidth={true}
                                           id="valuePaid"
                                           value={this.state.valuePaid}
                                           onChange={this.handlePaidValue}
                                           label="Valor Pago"
                                           placeholder="Valor já pago"
                                           disabled={!editable}
                                           data-empty-error-message="Não pode estar vazio" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="fieldHolder">
                                <TextField fullWidth={true}
                                           id="notes"
                                           value={this.state.notes}
                                           onChange={this.handleFieldChange}
                                           disabled={!editable}
                                           multiline={true}
                                           rows={4}
                                           label="Observações" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 buttonsHolder text-center">
                            <Button onClick={this.handleCancel} variant="contained" className="defaultButton float-left">Cancelar</Button>
                            {editable && canDelete && this.state.clientServiceId !== "New" && <Button onClick={this.handleDelete} className="button button-danger float-left" variant="contained">Apagar Serviço</Button>}
                            {editable && <Button onClick={this.handleOk} className="button  float-right" variant="contained" color="primary">Salvar</Button>}
                        </div>
                    </div>
                </div>
                <div className={"darkOverlay active"}></div>
            </div>
        );
    }
}

export default ServiceModalBox;
